import { ModalContainer, ModalList, type ModalListItem } from 'src/components/ModalContainer';

interface BulkActionsPickerProps<ItemT extends ModalListItem> {
  open: boolean;
  options: ItemT[];
  onClose: () => void;
  onSelect: (item: ItemT) => void;
}

export const BulkActionsPicker = <ItemT extends ModalListItem>({
  open,
  options,
  onClose,
  onSelect,
}: BulkActionsPickerProps<ItemT>) => (
  <ModalContainer
    open={open}
    size="medium"
    title="Bulk actions"
    onClose={onClose}
    data-testid="bulk-actions-picker"
  >
    <ModalList items={options} onSelect={onSelect} testId="bulk-actions-picker" />
  </ModalContainer>
);
